/**
 * Converts a DateTime string to readable date time.
 * @param {string} input - The DateTime returned input.
 * @param {boolean} omitTime - Whether the time portion should be omitted
 */

const _convertDate = (input,omitTime = false) => {
    const date = new Date(input);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    if(!omitTime)
        return `${month}/${day}/${year} ${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${ampm}`;
    else
         return `${month}/${day}/${year}`;
}

export {_convertDate}